import { css } from 'aphrodite';
import * as React from 'react';
import { bs } from '../../../../../web/styles/styles';

export function CampaignTemplatesByIndustrySearchTable({
	firstColumnHeader,
	children,
}: {
	firstColumnHeader: React.ReactNode;
	children: React.ReactNode;
}) {
	return (
		<div className={css(bs.border0, bs.borderB, bs.borderSolid, bs.borderNameCircles, bs.pb8, bs.mb8)}>
			<table className={css(bs.borderSpacing0, bs.borderCollapse, bs.wFull)}>
				<thead>
					<tr>
						<th>{firstColumnHeader}</th>
						<th className={css(bs.p4, bs.textXs, bs.textHeader, bs.fontNormal)}>Industries</th>
						<th className={css(bs.p4, bs.textXs, bs.textHeader, bs.fontNormal)}>Created</th>
						<th className={css(bs.p4, bs.textXs, bs.textHeader, bs.fontNormal)}>Actions</th>
					</tr>
				</thead>
				<tbody className={css(bs.border0, bs.borderX, bs.borderGray200, bs.borderSolid)}>{children}</tbody>
			</table>
		</div>
	);
}

export function CampaignTemplatesByIndustrySearchTableRow({ children }: { children: React.ReactNode }) {
	return <tr className={css()}>{children}</tr>;
}

export function CampaignTemplatesByIndustrySearchTableCell({ children }: { children: React.ReactNode }) {
	return <td className={css(bs.p4, bs.border0, bs.borderY, bs.borderSolid, bs.borderGray200)}>{children}</td>;
}
